var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications-list"},_vm._l((_vm.notifications),function(notification){return _c('single-notification',{key:notification.id,staticClass:"mt-3",attrs:{"notification":notification},on:{"close":function($event){return _vm.$emit('close')}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }